import * as types from './mutation-types'

export const countriesInfo = ({ commit }, payload) => {
    commit(types.COUNTRIES_INFO, payload)
}

export const peerInfo = ({ commit }, payload) => {
    commit(types.PEER_INFO, payload)
}

export const notifyPending = ({ commit }, payload) => {
    commit(types.NOTIFY_PENDING, payload)
}

export const postalCodeCache = ({ commit }, payload) => {
    commit(types.POSTAL_CODE_CACHE, payload)
}

export default {
    countriesInfo,
    peerInfo,
    notifyPending,
    postalCodeCache
}
